import React, { useState } from "react";
import "./MobileView.css";

const MobileView = ({ url, textContent }) => {
  return (
    <div className="mobile-view-container">
      <div className="mobile-phone-frame">
        <div className="mobile-header">
          <div className="notch"></div>
        </div>
        <iframe src={url} title="Mobile View" className="mobile-screen" />
      </div>
    </div>
  );
};

export default MobileView;
